import {Checkbox, CheckboxProps} from 'evergreen-ui';
import React from 'react';
import {Control, Controller, FieldError, useFormContext, RegisterOptions} from 'react-hook-form';
import {ValidationMessage} from './ValidationMessage';

type ValidatedSelectFieldProps<T> = {
    validationRules?: RegisterOptions,
    name: keyof T,
} & Omit<CheckboxProps, 'name'>;
export const ValidatedCheckboxField = <T extends Record<string, any>, >
({
     validationRules,
     name,
     ...checkboxProps
 }: ValidatedSelectFieldProps<T>
) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<T>();
    return (
        <Controller
            name={name.toString()}
            control={control as Control<Record<string, any>>}
            rules={validationRules}
            render={({field: {onChange, onBlur, value}}) => {
                const props = {
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked),
                    ...checkboxProps,
                    onBlur,
                    checked: value ? value : undefined,
                    // @ts-ignore
                    isInvalid: !!errors[name],
                };
                return (<Checkbox {...props}><ValidationMessage
                    // @ts-ignore
                    error={errors[name] as FieldError | undefined}/></Checkbox>);
            }}
        />
    );
}
